import PropTypes from "prop-types"

import { cn } from "styles/utils"

const ItemContainer = ({ className, ...props }) => (
  <li
    className={cn(
      "tablet:mb-30 relative mx-auto mb-24 mt-4 px-8 text-center",
      className
    )}
    {...props}
  />
)

ItemContainer.propTypes = {
  className: PropTypes.string,
}

export default ItemContainer
